module.exports = __webpack_public_path__ + "img/Ventuar_Wooden Shield.c1995506.png";